import React, { useEffect, useState } from "react";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { TabView, TabPanel } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";

import "./style.css";

import ModalSeplag from "../../components/ModalSeplag";
import RotuloSeplag from "../../components/RotuloSeplag";
import CardSeplag from "../../components/CardSeplag";
import TableSeplag from "../../components/TableSeplag";

import { Form as initForm, pesquisarAll, atualizarPerfil, remover } from "../../service/Seguranca/usuario";
import { detailExclusaoSucessoPadrao, printToast, summaryExclusaoSucessoPadrao } from "../../config/global";
import { salvarPerfil } from "../../service/Seguranca/PerfilAcessos";

const CadastroPerfil = () => {
  const nivelAcesso = [
    {
      name: "Administrador do Sistema",
      code: "SISTEMA",
    },
    {
      name: "Administrador Setorial",
      code: "SETORIAL",
    },
    {
      name: "Operador do Sistema",
      code: "OPERADOR",
    },
  ];

  const filtroVisualizacao = [
    {
      name: "Todos",
      code: "TODOS",
    },
    {
      name: "Somente o Setor de Lotação",
      code: "SETOR",
    },
    {
      name: "Somente os registros cadastrados",
      code: "CADASTRO",
    },
  ];

  const getCadastroPerfil = {
    id: null,
    nomePerfilAcesso: null,
    nivelAcesso: null,
    filtroVisualizacao: null,
    autorizacoes: [],
    autorizacoesSelecionadas: [],
  };

  const [exibirModalPerfil, setExibirModalPerfil] = useState(false);
  const [perfilSelecionado, setperfilSelecionado] = useState(getCadastroPerfil);
  const [perfis, setperfil] = useState([]);
  const [autorizacoes, setAutorizacoes] = useState([]);
  const [autorizacoesSelecionadas, setAutorizacoesSelecionadas] = useState(null);
  const [labelModalAcao, setLabelModalAcao] = useState("Cadastrar");

  const camposTabela = [
    { titulo: "Perfil de Acesso", nome: "nomePerfilAcesso" },
    { titulo: "Sistema", nome: "sistema.nomeSistema" },
  ]

  useEffect(() => {
    carregarDadosAutorizacao();
    carregarDadosPerfil();
  }, []);

  async function carregarDadosAutorizacao() {
    let res = await window.$http.get(`/seguranca/autorizacaos/view`);
    if (res.status == 200) {
      setAutorizacoes(res.data);
    }
  }

  async function carregarDadosPerfil() {
    let res = await window.$http.get(`/seguranca/perfilacessos`);
    if (res.status == 200) {
      setperfil(res.data);
    }
  }

  function fecharModalPerfil() {
    setExibirModalPerfil(false);
  }


  const onExcluir = (data) => {
    remover(data).then(() => {
      pesquisarAll().then((res) => {
        setExibirModalPerfil(res.status);
        printToast({ summary: summaryExclusaoSucessoPadrao, detail: detailExclusaoSucessoPadrao });
      });
    });
  };


  function abreModalPerfil(perfilSelecionado = []) {
    if (perfilSelecionado) {
      setperfilSelecionado(perfilSelecionado);
      setAutorizacoesSelecionadas(perfilSelecionado.autorizacoes);
      setExibirModalPerfil(true);
      setLabelModalAcao("Salvar");
    } else {
      setperfilSelecionado(getCadastroPerfil);
      setExibirModalPerfil(true);
      setLabelModalAcao("Cadastrar");
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    let JsonPost = {
      ...perfilSelecionado
    }

    JsonPost.autorizacoesSelecionadas = [...autorizacoesSelecionadas]

    salvarPerfil(JsonPost).then(res => {
      carregarDadosPerfil();
      fecharModalPerfil();
    })

    // atualizarPerfil(JsonPost).then(res => {
    //   carregarDadosPerfil();
    //   fecharModalPerfil();
    // })
  }

  const onEditarDado = (e) => {
    setperfilSelecionado(e)
    abreModalPerfil(e)
  }


  return (
    <>

      <CardSeplag title="Cadastro de Perfis">
        <div className="p-grid p-fluid p-col" >
          <div className="p-col-12 p-md-2" style={{ paddingBottom: 20 }}>
            {/* <Button
              label="Novo Perfil"
              icon="pi pi-re"
              className="p-button-info"
              onClick={() => {
                abreModalPerfil();
              }}
            /> */}
          </div>
          <div className="p-col-12">
            <TableSeplag
              hasEventoAcao
              camposTabela={camposTabela}
              dados={perfis}
              onEditarDado={onEditarDado}
              onExcluirDado={onExcluir}
            />

          </div>
        </div>
      </CardSeplag>

      <ModalSeplag titulo="Novo Cadastro" tamanho="50vw" type={"NONE"} labelFechar="Fechar" labelAcao={labelModalAcao} visible={exibirModalPerfil} fechar={fecharModalPerfil}>

        <form style={{ marginTop: "5px" }} onSubmit={handleSubmit} className="p-col-12 p-grid">
          <TabView className="tabview-cadastro p-col-12">
            <TabPanel header="Cadastro" rightIcon="pi pi-user-edit">
              <div className="p-grid p-fluid preenchimento-baixo">
                <RotuloSeplag nome="Nome:">
                  <InputText type="text" value={perfilSelecionado.nomePerfilAcesso} onChange={(e) => setperfilSelecionado({ ...perfilSelecionado, nomePerfilAcesso: e.target.value })} />
                </RotuloSeplag>
                <RotuloSeplag nome="Nível de Acesso:" cols="12 6">
                  <Dropdown value={perfilSelecionado.nivelAcesso} options={nivelAcesso} optionLabel="name" optionValue="code" onChange={(e) => setperfilSelecionado({ ...perfilSelecionado, nivelAcesso: e.value })} placeholder="Selecione um Perfil" />
                </RotuloSeplag>
                <RotuloSeplag nome="Filtro Visualização:" cols="12 6">
                  <Dropdown value={perfilSelecionado.filtroVisualizacao} options={filtroVisualizacao} optionLabel="name" optionValue="code" onChange={(e) => setperfilSelecionado({ ...perfilSelecionado, filtroVisualizacao: e.value })} placeholder="Selecione um Filtro Visualização" />
                </RotuloSeplag>
              </div>
            </TabPanel>
            <TabPanel header="Autorizações" rightIcon="pi pi-cog">
              <DataTable value={autorizacoes} selection={autorizacoesSelecionadas} onSelectionChange={(e) => setAutorizacoesSelecionadas(e.value)} dataKey="key" className="p-datatable-gridlines">
                <Column selectionMode="multiple" headerStyle={{ width: "3em" }}></Column>
                <Column field="data.nomeExibir" header="Nome"></Column>
                <Column field="data.descricaoAutorizacao" header="Descrição"></Column>
              </DataTable>
            </TabPanel>
          </TabView>
          <div className="p-col-12 p-md-3">
            <Button type='submit' label={"Salvar"} icon={"pi pi-check"} autoFocus className={"p-button-raised p-mb-1"} />
          </div>
          <div className="p-col-12 p-md-3">
            <Button type='button' label="Cancelar" icon="pi pi-times" onClick={fecharModalPerfil} className="p-button-outlined p-button-danger p-mb-1" />
          </div>
        </form>

      </ModalSeplag>

    </>
  );
};

export default CadastroPerfil;
